import React, { useState, useEffect, useRef } from "react";
import { api } from "../../components/Api/api";
import "./home.css";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Space,
  Select,
  Row,
  Col,
  Upload,
  message,
  Image,
  Collapse,
  ColorPicker,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Loading from "../../components/Loading";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../components/Auth";
import { generateRandomString } from "../../tools";
import CKEditorForm from "../../utility/CKEditorForm";
import JSONEditorReact from "../../components/JSONEditorReact";

const { Option } = Select;
const { Item } = Form;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 6 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 18 },
    lg: { span: 18 },
  },
};

const socialOptions = [
  { key: "facebook", value: "Facebook" },
  { key: "youtube", value: "Youtube" },
];

const languageOptions = [
  { key: "km", value: "Campuchia" },
  { key: "th", value: "Thái Lan" },
  { key: "id", value: "Indonesia" },
  { key: "ko", value: "Hàn Quốc" },
];

const appOptions = [
  { key: "chplay", value: "CHPlay (Google Play)" },
  { key: "appstore", value: "AppStore" },
];

const imgOptions = ["icon", "logo_bottom", "img", "default_facebook_img"];

//const host = 'https://cdn.anvui.vn/';

const modes = ["tree", "form", "view", "code", "text"];

function Home() {
  const [data, setData] = useState({});
  const [imageHolder, setImageHolder] = useState({});
  const [loading, setLoading] = useState(false);
  const [areaData, setAreaData] = useState("");
  const [areaData2, setAreaData2] = useState("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const createTime = useRef(Math.floor(Date.now() / 1000));

  const [state, setState] = useState({
    text: JSON.stringify({}, null, 2),
    mode: "code",
  });

  const onChangeText = (text) => {
    setState((prevState) => ({
      ...prevState,
      text,
    }));
  };

  const onModeChangeSelect = (event) => {
    setState((prevState) => ({
      ...prevState,
      mode: event.target.value,
    }));
  };

  const onModeChange = (mode) => {
    setState((prevState) => ({
      ...prevState,
      mode: mode ? mode : "tree",
    }));
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await api.get(location.pathname);
      console.log("res", res.data.s_name);
      const procData = processData(res.data, "in");
      const footer_info = procData.footer_info;
      const short_intro = procData.short_intro;
      createTime.current = procData.create_time;
      procData.sdk_ = `
<script src="https://${res.data.s_name}.phanmembanve.vn/anvui-sdk-iframe.js"></script>

<div class="iframe-container">
  <iframe
    src="https://${res.data.s_name}.phanmembanve.vn"
    width="100%"
    id="myIframe"
    style="border: none; display: block; min-height: 452px"
    scrolling="no"
    onload="resizeIframe()"
    onresize="resizeIframe()"
  ></iframe>
</div>
   `;
      const dynamic_config = procData.dynamic_config || "{}";
      setState((prevState) => ({
        ...prevState,
        text: dynamic_config,
      }));
      setAreaData(footer_info);
      setAreaData2(short_intro);
      setData(procData);
      form.setFieldsValue(procData);
      resetImageHolder(procData);
    } catch (err) {
      console.error(err);
      if (err === 401) {
        auth.signOut(() => navigate("/login"));
      } else {
        navigate("/error");
      }
    } finally {
      setLoading(false);
    }
  };

  const resetImageHolder = (data) => {
    const images = imgOptions.reduce((acc, key) => {
      if (data[key]) {
        acc[key] = data[key];
      }
      return acc;
    }, {});

    setImageHolder(images);
  };

  function isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  }

  //process data
  const processData = (data, type) => {
    if (type === "in") {
      const displaybyDefault = isValidJSON(data?.display_by_default)
        ? JSON.parse(data?.display_by_default || "{}")
        : {};
      data.address = data?.address ? JSON.parse(data?.address || "{}") : "";
      data.apps = data?.apps ? JSON.parse(data?.apps || "{}") : "";
      data.socials = data?.socials ? JSON.parse(data?.socials || "{}") : "";
      data.google_tag_head = data?.google_tag_head
        ? atob(data?.google_tag_head)
        : "";
      data.google_tag_body = data?.google_tag_head
        ? atob(data?.google_tag_body)
        : "";
      data.facebook_messenger = data?.facebook_messenger
        ? atob(data?.facebook_messenger)
        : "";
      data.lang_addtionals = JSON.parse(data?.lang_addtionals || "[]");
      data.promotions =
        displaybyDefault.promotions !== undefined
          ? displaybyDefault.promotions
          : true;
      data.news =
        displaybyDefault.news !== undefined ? displaybyDefault.news : true;
      data.newsletter =
        displaybyDefault.newsletter !== undefined
          ? displaybyDefault.newsletter
          : true;

      // imgOptions.forEach(item => data[item] = host + data[item]);
    } else if (type === "out") {
      data.address = JSON.stringify(data.address);
      data.apps = JSON.stringify(data.apps);
      data.socials = JSON.stringify(data.socials);
      data.google_tag_head = btoa(data.google_tag_head);
      data.google_tag_body = btoa(data.google_tag_body);
      data.lang_addtionals = JSON.stringify(data.lang_addtionals);
      data.facebook_messenger = btoa(data.facebook_messenger);

      data.dynamic_config = JSON.stringify(JSON.parse(state.text)) || "{}";
      const display_by_default = {
        promotions: data.promotions || false,
        news: data.news || false,
        newsletter: data.newsletter || false,
      };
      data.display_by_default = JSON.stringify(display_by_default);
      // imgOptions.forEach(item => data[item] = data[item].replace(host, ""))
    }

    console.log(data);

    return data;
  };

  const handleFileUpload = async (file, type) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG images!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return false;
    }

    setImageHolder({ ...imageHolder, [type]: URL.createObjectURL(file) });
    form.setFieldValue(type, { file: file, name: file.name });

    return false; // Prevent default upload behavior
  };

  const handleAreaData = (e) => {
    setAreaData(e);
  };

  const handleAreaData2 = (e) => {
    setAreaData2(e);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onFinish = async (values) => {
    values.footer_info = areaData;
    values.short_intro = areaData2;
    const formData = new FormData();
    let imgIndex = 0;
    imgOptions.forEach((item) => {
      if (values[item] && typeof values[item] === "object") {
        const { file } = values[item] || {};
        formData.append("files", file);
        formData.append(`key_${imgIndex}`, item);
        imgIndex++;
      }
    });

    setLoading(true);
    await api
      .put("/home/upload-file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        res.data.forEach((item) => (values[item.name] = item.url));
      })
      .catch((err) => {
        navigate("/error");
        return;
      });
    await api
      .put(location.pathname, processData(values, "out"))
      .then((res) => {
        fetchData();
        window.scrollTo(0, 0);
        setLoading(false);
        message.success(res.data.msg);
      })
      .catch((err) => {
        navigate("/error");
      });
  };

  const cancel = () => {
    form.resetFields();
    resetImageHolder(data);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Form
          {...formItemLayout}
          form={form}
          initialValues={data}
          name="dynamic_form_nest_item"
          onFinish={onFinish}
        >
          <Item label="Tên công ty" name="business">
            <Input />
          </Item>

          <div className="form-upload">
            <Row justify="center" align="center" gutter={16}>
              <Col span={6} />
              <Col span={4}>
                <Item name="img">
                  <Upload.Dragger
                    beforeUpload={(file) => handleFileUpload(file, "img")}
                    showUploadList={false}
                    name="img"
                  >
                    <Image src={imageHolder.img} preview={false} />
                  </Upload.Dragger>
                  <div className="form-upload-label">
                    <label>Logo trên</label>
                  </div>
                </Item>
              </Col>
              <Col span={4}>
                <Item name="logo_bottom">
                  <Upload.Dragger
                    beforeUpload={(file) =>
                      handleFileUpload(file, "logo_bottom")
                    }
                    showUploadList={false}
                    name="logo_bottom"
                  >
                    <Image src={imageHolder.logo_bottom} preview={false} />
                  </Upload.Dragger>
                  <div className="form-upload-label">
                    <label>Logo dưới</label>
                  </div>
                </Item>
              </Col>
              <Col span={4}>
                <Item name="icon">
                  <Upload.Dragger
                    beforeUpload={(file) => handleFileUpload(file, "icon")}
                    showUploadList={false}
                    name="icon"
                  >
                    <Image src={imageHolder.icon} preview={false} />
                  </Upload.Dragger>
                  <div className="form-upload-label">
                    <label>favicon</label>
                  </div>
                </Item>
              </Col>
              <Col span={4}>
                <Item name="default_facebook_img">
                  <Upload.Dragger
                    beforeUpload={(file) =>
                      handleFileUpload(file, "default_facebook_img")
                    }
                    showUploadList={false}
                    name="default_facebook_img"
                  >
                    <Image
                      src={imageHolder.default_facebook_img}
                      preview={false}
                    />
                  </Upload.Dragger>
                  <div className="form-upload-label">
                    <label>Facebook share mặc định</label>
                  </div>
                </Item>
              </Col>
            </Row>
          </div>
          <Item label="Subdomain" name="s_name" disabled={true}>
            <Input disabled={true} />
          </Item>
          <Item label="Giấy chứng nhận DKKD" name="dkkd">
            <Input />
          </Item>
          <Item label="Đường dẫn DK BCT" name="bct_link">
            <Input />
          </Item>
          <Item label="Giới thiệu chung" name="short_intro">
            <CKEditorForm
              data={areaData2}
              handleChange={handleAreaData2}
              url="/news/create-news/upload-image"
              name={createTime.current}
            />
          </Item>

          <Item label="Số điện thoại" name="phone">
            <Input />
          </Item>
          <Item label="Hotline" name="hotline">
            <Input />
          </Item>
          <Item label="Email" name="email">
            <Input />
          </Item>
          <Item label="Map" name="map">
            <Input.TextArea rows={5} />
          </Item>
          <Item label="Google Tag Manager Head" name="google_tag_head">
            <Input.TextArea rows={4} />
          </Item>
          <Item label="Google Tag Manager Body" name="google_tag_body">
            <Input.TextArea rows={4} />
          </Item>
          <Item label="Facebook Messenger" name="facebook_messenger">
            <Input.TextArea rows={4} />
          </Item>
          <Item label="Block Spam Keywords" name="block_spam_keywords">
            <Input.TextArea rows={4} />
          </Item>

          <Item label="Địa chỉ">
            <Form.List name="address">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                      }}
                      align="baseline"
                    >
                      <Item {...restField} name={[name, "key"]}>
                        <Input placeholder="Tên" />
                      </Item>
                      <Item {...restField} name={[name, "value"]}>
                        <Input placeholder="Nội dung" />
                      </Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                    ></Button>
                  </Item>
                </>
              )}
            </Form.List>
          </Item>

          <Item label="Mạng xã hội">
            <Form.List name="socials">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                      }}
                      align="baseline"
                    >
                      <Item {...restField} name={[name, "key"]}>
                        <Select placeholder="Chọn mạng xã hội">
                          {socialOptions.map((item, index) => (
                            <Option key={index} value={item.key}>
                              {item.value}
                            </Option>
                          ))}
                        </Select>
                      </Item>
                      <Item {...restField} name={[name, "value"]}>
                        <Input placeholder="Link" />
                      </Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                    ></Button>
                  </Item>
                </>
              )}
            </Form.List>
          </Item>

          <Item label="Màu chủ đạo" name="color">
            <ColorPicker
              onChange={(val) => form.setFieldValue("color", val.toHexString())}
            />
          </Item>

          <Item label="Màu phụ đạo" name="secondary_color">
            <ColorPicker
              onChange={(val) =>
                form.setFieldValue("secondary_color", val.toHexString())
              }
            />
          </Item>

          <Item label="Box tìm kiếm" name="search_point_type">
            <Select placeholder="Chọn loại tìm kiếm" style={{ width: 200 }}>
              <Option value="POINT">Tìm kiếm theo điểm</Option>
              <Option value="PROVINCE">Tìm kiếm theo tỉnh</Option>
            </Select>
          </Item>

          <Item
            label="Hiển thị mã ghế"
            valuePropName="checked"
            name="showSeatId"
          >
            <Checkbox />
          </Item>
          <Item
            label="Hiển thị Ưu đãi nổi bật"
            valuePropName="checked"
            name="promotions"
          >
            <Checkbox />
          </Item>
          <Item
            label="Hiển thị Tin tức và sự kiện"
            valuePropName="checked"
            name="news"
          >
            <Checkbox />
          </Item>
          <Item
            label="Hiển thị Đăng ký để nhận tin tức"
            valuePropName="checked"
            name="newsletter"
          >
            <Checkbox />
          </Item>
          <Item
            label="Tích hợp Zalo OA Chat"
            valuePropName="checked"
            name="zaloOAEmbed"
          >
            <Checkbox />
          </Item>
          <Item label="Zalo Data-oa id" name="zaloOAEmbedId">
            <Input />
          </Item>
          <Item label="Sử dụng iframe" valuePropName="checked" name="use_frame">
            <Checkbox />
          </Item>
          <Item
            label="Sử dụng đa ngôn ngữ"
            valuePropName="checked"
            name="use_multi_lang"
          >
            <Checkbox />
          </Item>
          <Item label="Ngôn ngữ dịch qua google" name="lang_addtionals">
            <Select
              placeholder="Chọn ngôn ngữ"
              style={{ width: "400px" }}
              mode="multiple"
            >
              {languageOptions.map((item, index) => (
                <Option key={index} value={item.key}>
                  {item.value}
                </Option>
              ))}
            </Select>
          </Item>
          <Item
            label="Ẩn box đặt vé web, app khách hàng"
            valuePropName="checked"
            name="use_route_home"
          >
            <Checkbox />
          </Item>

          <Item
            label="Hiển thị hình ảnh tuyến trên app khách hàng"
            valuePropName="checked"
            name="use_route_image"
          >
            <Checkbox />
          </Item>

          <Item label="App">
            <Form.List name="apps">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                      }}
                      align="baseline"
                    >
                      <Item {...restField} name={[name, "key"]}>
                        <Select placeholder="Chọn mạng xã hội">
                          {appOptions.map((item, index) => (
                            <Option key={index} value={item.key}>
                              {item.value}
                            </Option>
                          ))}
                        </Select>
                      </Item>
                      <Item {...restField} name={[name, "value"]}>
                        <Input placeholder="Link app" />
                      </Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                    ></Button>
                  </Item>
                </>
              )}
            </Form.List>
          </Item>
          <Item wrapperCol={{ offset: 6 }}>
            <Collapse
              accordion
              expandIcon={({ isActive }) => <p rotate={isActive ? 90 : 0} />}
            >
              <Collapse.Panel header="SEO" key="1">
                <Item label="Meta Title" name="meta_title">
                  <Input className="form-input" />
                </Item>
                <Item label="Meta Keyword" name="meta_keyword">
                  <Input className="form-input" />
                </Item>
                <Item label="Meta Description" name="meta_description">
                  <Input className="form-input" />
                </Item>
              </Collapse.Panel>
            </Collapse>
          </Item>
          <Item label="Nội dung" name="footer_info">
            <CKEditorForm
              data={areaData}
              handleChange={handleAreaData}
              url="/news/create-news/upload-image"
              name={createTime.current}
            />
          </Item>
          <Item label="Hướng dẫn nhúng Iframe" name="sdk_">
            <Input.TextArea readOnly value={""} autoSize />
          </Item>
          <Item label="Cấu hình động" name="dynamic_config">
            <JSONEditorReact
              schema={state.schema}
              text={state.text}
              mode={state.mode}
              modes={modes}
              indentation={4}
              onChangeText={onChangeText}
              onModeChange={onModeChange}
            />
          </Item>
          <Item wrapperCol={{ offset: 6 }}>
            <Space>
              <Button type="primary" htmlType="submit">
                Lưu
              </Button>
              <Button type="default" onClick={() => cancel()}>
                Huỷ
              </Button>
            </Space>
          </Item>
        </Form>
      )}
    </>
  );
}

export default Home;
